module.exports = __webpack_public_path__ + "images/favicons/favicon-momentum-16.d8422777.png";